module.exports = __webpack_public_path__ + "img/724.061a7b14.jpg";